var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17467 4.70687C1.66797 5.7798 1.66797 7.31171 1.66797 10C1.66797 13.1248 1.66797 14.6872 2.46373 15.7824C2.72073 16.1362 3.0318 16.4472 3.38553 16.7042C4.4808 17.5 6.04319 17.5 9.16797 17.5H10.8346C13.9594 17.5 15.5218 17.5 16.6171 16.7042C16.9708 16.4472 17.2819 16.1362 17.5389 15.7824C18.3346 14.6872 18.3346 13.1248 18.3346 10C18.3346 7.29271 18.3346 5.75821 17.8171 4.68419M2.17467 4.70687C2.25695 4.53266 2.35258 4.37055 2.46373 4.21756C2.72073 3.86383 3.0318 3.55276 3.38553 3.29576C4.4808 2.5 6.04319 2.5 9.16797 2.5H10.8346C13.9594 2.5 15.5218 2.5 16.6171 3.29576C16.9708 3.55276 17.2819 3.86383 17.5389 4.21756C17.6452 4.3639 17.7373 4.51857 17.8171 4.68419M2.17467 4.70687L2.5013 5L4.10875 6.60744C6.88652 9.38522 8.27541 10.7741 10.0013 10.7741C11.7272 10.7741 13.1161 9.38522 15.8939 6.60745L17.5013 5L17.8171 4.68419",
    stroke: "url(#paint0_radial_100_2858)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_100_2858",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.87122 16.3462) rotate(-38.5626) scale(21.0549 55.7293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.b5a6d9ead9ca025d8e44aa9338edd606.svg";
export { ForwardRef as ReactComponent };